import * as deepmerge from "deepmerge";
import {ENVIRONMENT_GLOBAL} from "./global";

export const environment = deepmerge.all([{}, ENVIRONMENT_GLOBAL, {
  stand: 'dev',
  production: true,
  backend: {
    analyticalTasks: 'https://big-expert.test.dfsystems.ru/analytical-tasks-service',
    schedulerService: 'https://big-expert.test.dfsystems.ru/scheduler-service',
    users: 'https://big-expert.test.dfsystems.ru/users-service',
    nsi: 'https://big-expert.test.dfsystems.ru/mdm-service',
    responsibles: 'https://big-expert.test.dfsystems.ru/responsibles-service',
    contracts: 'https://big-expert.test.dfsystems.ru/it-plan/contracts',
    activities: 'https://big-expert.test.dfsystems.ru/activities-service',
    purchases: 'https://big-expert.test.dfsystems.ru/procurement-service',
    planning: 'https://big-expert.test.dfsystems.ru/planning-service',
    bpm: 'https://big-expert.test.dfsystems.ru/bpm-service',
    fileStorage: 'https://big-expert.test.dfsystems.ru/file-storage-service',
    sessionStorage: 'https://big-expert.test.dfsystems.ru/bdpk-acl',
    rsaaOAuth: '/bdpk-acl/oauth?mode=kk'
  },
  reporting: {
    redirectService: 'https://big-expert.test.dfsystems.ru/bdpk-acl',
    saikuReportsURLPattern: 'https://big-expert.test.dfsystems.ru/pentaho/api/repos/%URL%/generatedContent?userid=admin&password=password',
    hueURLPattern: 'http://95.217.47.123:38488/hue/%URL%',
    sparkURLPattern: 'http://95.217.47.123:38480/%URL%',
    fileURLPattern: 'https://big-expert.test.dfsystems.ru/files/%URL%',
    rstudioURLPattern: 'http://95.217.47.123:39187/%URL%',
    jupyterURLPattern: 'http://95.217.47.123:39188/?token=5d4ff651116e716f8a84d81cdf214b2b61f433a9eca38490'
  }
}]) as any;
